export default "__VITE_ASSET__C5xg0Xyq__"